import {
    ADD_CONJOINT_ATTRIBUTE,
    ADD_CONJOINT,
    FETCH_CONJOINT,
    FETCH_CONJOINTS,
    SHOW_ERROR,
    EDIT_CONJOINT_ATTRIBUTE,
    MOVE_CONJOINT_ATTRIBUTE,
    DELETE_CONJOINT_ATTRIBUTE,
    EDIT_CONJOINT_PRICES,
    ADD_CONJOINT_EXCLUSION,
    EDIT_CONJOINT_EXCLUSION,
    DELETE_CONJOINT_EXCLUSION,
    EDIT_CONJOINT_SETTINGS,
    FETCH_CONJOINT_PREVIEW,
    ADD_GABOR_GRANGER,
    FETCH_GABOR_GRANGER,
    FETCH_GABOR_GRANGERS,
    EDIT_GABOR_GRANGER_PRICES,
    EDIT_GABOR_GRANGER_PRODUCT,
    EDIT_GABOR_GRANGER_SETTINGS,
    FETCH_GABOR_GRANGER_PREVIEW,
    ADD_VAN_WESTENDORP,
    FETCH_VAN_WESTENDORP,
    FETCH_VAN_WESTENDORPS,
    EDIT_VAN_WESTENDORP_PRODUCT,
    EDIT_VAN_WESTENDORP_SETTINGS,
    ADD_SURVEY,
    FETCH_PRODUCTS,
    ADD_FIRMOGRAPHIC,
    FETCH_FIRMOGRAPHICS,
    FETCH_FIRMOGRAPHIC,
    ADD_FIRMOGRAPHIC_QUESTION,
    EDIT_FIRMOGRAPHIC_QUESTION,
    MOVE_FIRMOGRAPHIC_QUESTION,
    DELETE_FIRMOGRAPHIC_QUESTION,
    FETCH_SURVEYS,
    FETCH_SURVEY,
    EDIT_SURVEY_DESIGN,
    ADD_SURVEY_RESPONDENT,
    EDIT_SURVEY_RESPONDENT,
    DELETE_SURVEY_RESPONDENT,
    TOGGLE_CONJOINT_READY,
    TOGGLE_FIRMOGRAPHIC_READY,
    TOGGLE_GABOR_GRANGER_READY,
    TOGGLE_VAN_WESTENDORP_READY,
    FETCH_TEST_SURVEY,
    TAKE_SURVEY,
    ANSWER_SURVEY,
    START_SURVEY,
    ANALYZE_SURVEY
} from './types'
import errorObject from '../components/helpers/errorObject';
import history from '../history';
import auth from '../apis/auth';
import { postAction, getAction } from './actionFunctions';

export const addSurvey = (formValues) => async dispatch => {
    await auth.post('/api/survey/create_survey', formValues)
        .then(response => {
            const id = response.data.id
            dispatch({ type: ADD_SURVEY, payload: response.data })
            history.push(`/surveys/survey?id=${id}`)
        })
        .catch(error => {
            if (error.response.data.detail.constructor === Array) {
                const errorObj = errorObject(error.response.data.detail)
                dispatch({ type: SHOW_ERROR, payload: errorObj })
            }
            else {
                dispatch({ type: SHOW_ERROR, payload: error.response.data });
            }
        })
}

export const fetchSurveys = () => async dispatch => {
    await auth.get('/api/survey/get_surveys')
        .then(response => {
            dispatch({ type: FETCH_SURVEYS, payload: response.data })
        })
        .catch(error => {
            dispatch({ type: SHOW_ERROR, payload: error.response.data });
        })
}

export const fetchSurvey = (id) => async dispatch => {
    await auth.get(`/api/survey/get_survey?id=${id}`)
        .then(response => {
            dispatch({ type: FETCH_SURVEY, payload: response.data })
        })
        .catch(error => {
            dispatch({ type: SHOW_ERROR, payload: error.response.data });
        })
}

export const startSurvey = (id) => async dispatch => {
    await auth.get(`/api/survey/start_survey?id=${id}`)
        .then(response => {
            dispatch({ type: START_SURVEY, payload: response.data })
        })
        .catch(error => {
            dispatch({ type: SHOW_ERROR, payload: error.response.data });
        })
}

export const analyzeSurvey = (id) => async dispatch => {
    await auth.get(`/api/survey/analyze_survey?id=${id}`)
        .then(response => {
            dispatch({ type: ANALYZE_SURVEY, payload: response.data })
        })
        .catch(error => {
            dispatch({ type: SHOW_ERROR, payload: error.response.data });
        })
}

export const takeSurvey = (survey_id) => async dispatch => {
    await auth.get(`/api/survey/take_survey?survey_id=${survey_id}`)
        .then(response => {
            dispatch({ type: TAKE_SURVEY, payload: response.data })
        })
        .catch(error => {
            dispatch({ type: SHOW_ERROR, payload: error.response.data });
        })
}

export const answerSurvey = (survey_id, type, values) => async dispatch => {
    await auth.post(`/api/survey/survey_answer?survey_id=${survey_id}&type=${type}`, values)
        .then(response => {
            dispatch({ type: ANSWER_SURVEY, payload: response.data })
        })
        .catch(error => {
            if (error.response.data.detail.constructor === Array) {
                const errorObj = errorObject(error.response.data.detail)
                dispatch({ type: SHOW_ERROR, payload: errorObj })
            }
            else {
                dispatch({ type: SHOW_ERROR, payload: error.response.data });
            }
        })
}

export const fetchTestSurvey = (id) => async dispatch => {
    await auth.get(`/api/survey/get_test_survey?id=${id}`)
        .then(response => {
            dispatch({ type: FETCH_TEST_SURVEY, payload: response.data })
        })
        .catch(error => {
            dispatch({ type: SHOW_ERROR, payload: error.response.data });
        })
}

export const editSurveyDesign = (id, formValues) => async dispatch => {
    await auth.patch(`/api/survey/update_design?id=${id}`, formValues)
    .then(response => {
        dispatch({ type: EDIT_SURVEY_DESIGN, payload: response.data })
    })
    .catch(error => {
        if (error.response.data.detail.constructor === Array) {
            const errorObj = errorObject(error.response.data.detail)
            dispatch({ type: SHOW_ERROR, payload: errorObj })
        }
        else {
            dispatch({ type: SHOW_ERROR, payload: error.response.data });
        }
    })
}

export const addRespondent = (id, formValues) => async dispatch => {
    await auth.post(`/api/survey/create_respondent?id=${id}`, formValues)
        .then(response => {
            // const id = response.data.id
            dispatch({ type: ADD_SURVEY_RESPONDENT, payload: response.data })
            // history.push(`/surveys/firmographic?id=${id}`)
        })
        .catch(error => {
            if (error.response.data.detail.constructor === Array) {
                const errorObj = errorObject(error.response.data.detail)
                dispatch({ type: SHOW_ERROR, payload: errorObj })
            }
            else {
                dispatch({ type: SHOW_ERROR, payload: error.response.data });
            }
        })
}

export const editRespondent = (id, formValues) => async dispatch => {
    await auth.patch(`/api/survey/update_respondent?id=${id}`, formValues)
    .then(response => {
        dispatch({ type: EDIT_SURVEY_RESPONDENT, payload: response.data })
    })
    .catch(error => {
        if (error.response.data.detail.constructor === Array) {
            const errorObj = errorObject(error.response.data.detail)
            dispatch({ type: SHOW_ERROR, payload: errorObj })
        }
        else {
            dispatch({ type: SHOW_ERROR, payload: error.response.data });
        }
    })
}

export const deleteRespondent = (id, respondent_id) => async dispatch => {
    await auth.delete(`/api/survey/delete_respondent?id=${id}&respondent_id=${respondent_id}`)
    .then(response => {
        dispatch({ type: DELETE_SURVEY_RESPONDENT, payload: response.data })
    })
    .catch(error => {
        if (error.response.data.detail.constructor === Array) {
            const errorObj = errorObject(error.response.data.detail)
            dispatch({ type: SHOW_ERROR, payload: errorObj })
        }
        else {
            dispatch({ type: SHOW_ERROR, payload: error.response.data });
        }
    })
}

export const fetchProductsSurvey = () => async dispatch => {
    await auth.get('/api/survey/get_products')
        .then(response => {
            dispatch({ type: FETCH_PRODUCTS, payload: response.data })
        })
        .catch(error => {
            history.push('/products')
            // dispatch({ type: SHOW_ERROR, payload: error.response.data });
        })
}

export const addFirmographic = (formValues) => async dispatch => {
    await auth.post('/api/survey/create_firmographic', formValues)
        .then(response => {
            const id = response.data.id
            dispatch({ type: ADD_FIRMOGRAPHIC, payload: response.data })
            history.push(`/surveys/firmographic?id=${id}`)
        })
        .catch(error => {
            if (error.response.data.detail.constructor === Array) {
                const errorObj = errorObject(error.response.data.detail)
                dispatch({ type: SHOW_ERROR, payload: errorObj })
            }
            else {
                dispatch({ type: SHOW_ERROR, payload: error.response.data });
            }
        })
}

export const fetchFirmographics = () => async dispatch => {
    await getAction('/api/survey/get_firmographics', FETCH_FIRMOGRAPHICS, dispatch)
}

export const fetchFirmographic = (id) => async dispatch => {
    await auth.get(`/api/survey/get_firmographic?id=${id}`)
        .then(response => {
            dispatch({ type: FETCH_FIRMOGRAPHIC, payload: response.data })
        })
        .catch(error => {
            dispatch({ type: SHOW_ERROR, payload: error.response.data });
            history.push('/surveys')
        })
}

export const toggleFirmographicReady = (id) => async dispatch => {
    await auth.get(`/api/survey/firmographic/toggle_ready?id=${id}`)
        .then(response => {
            dispatch({ type: TOGGLE_FIRMOGRAPHIC_READY, payload: response.data })
        })
        .catch(error => {
            dispatch({ type: SHOW_ERROR, payload: error.response.data });
        })
}

export const addFirmographicQuestion = (id, formValues) => async dispatch => {
    await postAction(`/api/survey/firmographic/add_question?id=${id}`, ADD_FIRMOGRAPHIC_QUESTION, formValues, dispatch)
}

export const editFirmographicQuestion = (id, formValues) => async dispatch => {
    await auth.post(`/api/survey/firmographic/update_question?id=${id}`, formValues)
    .then(response => {
        dispatch({ type: EDIT_FIRMOGRAPHIC_QUESTION, payload: response.data })
    })
    .catch(error => {
        if (error.response.data.detail.constructor === Array) {
            const errorObj = errorObject(error.response.data.detail)
            dispatch({ type: SHOW_ERROR, payload: errorObj })
        }
        else {
            dispatch({ type: SHOW_ERROR, payload: error.response.data });
        }
    })
}

export const moveFirmographicQuestion = (id, question_id, action) => async dispatch => {
    await auth.get(`/api/survey/firmographic/move_question?id=${id}&question_id=${question_id}&action=${action}`)
    .then(response => {
        dispatch({ type: MOVE_FIRMOGRAPHIC_QUESTION, payload: response.data })
    })
    .catch(error => {
        if (error.response.data.detail.constructor === Array) {
            const errorObj = errorObject(error.response.data.detail)
            dispatch({ type: SHOW_ERROR, payload: errorObj })
        }
        else {
            dispatch({ type: SHOW_ERROR, payload: error.response.data });
        }
    })
    dispatch(fetchFirmographic(id))
}

export const deleteFirmographicQuestion = (id, question_id) => async dispatch => {
    await auth.delete(`/api/survey/firmographic/delete_question?id=${id}&question_id=${question_id}`)
    .then(response => {
        dispatch({ type: DELETE_FIRMOGRAPHIC_QUESTION, payload: response.data })
    })
    .catch(error => {
        if (error.response.data.detail.constructor === Array) {
            const errorObj = errorObject(error.response.data.detail)
            dispatch({ type: SHOW_ERROR, payload: errorObj })
        }
        else {
            dispatch({ type: SHOW_ERROR, payload: error.response.data });
        }
    })
} 

export const addConjoint = (formValues) => async dispatch => {
    await auth.post('/api/survey/create_conjoint', formValues)
        .then(response => {
            const id = response.data.id
            dispatch({ type: ADD_CONJOINT, payload: response.data })
            history.push(`/surveys/conjoint?id=${id}`)
        })
        .catch(error => {
            if (error.response.data.detail.constructor === Array) {
                const errorObj = errorObject(error.response.data.detail)
                dispatch({ type: SHOW_ERROR, payload: errorObj })
            }
            else {
                dispatch({ type: SHOW_ERROR, payload: error.response.data });
            }
        })
}

export const fetchConjoints = () => async dispatch => {
    await getAction('/api/survey/get_conjoints', FETCH_CONJOINTS, dispatch)
}

export const fetchConjoint = (id) => async dispatch => {
    await auth.get(`/api/survey/get_conjoint?id=${id}`)
        .then(response => {
            dispatch({ type: FETCH_CONJOINT, payload: response.data })
        })
        .catch(error => {
            dispatch({ type: SHOW_ERROR, payload: error.response.data });
            history.push('/surveys')
        })
}

export const toggleConjointReady = (id) => async dispatch => {
    await auth.get(`/api/survey/conjoint/toggle_ready?id=${id}`)
        .then(response => {
            dispatch({ type: TOGGLE_CONJOINT_READY, payload: response.data })
        })
        .catch(error => {
            dispatch({ type: SHOW_ERROR, payload: error.response.data });
        })
}

export const addConjointAttribute = (id, formValues) => async dispatch => {
    await postAction(`/api/survey/conjoint/add_attribute?id=${id}`, ADD_CONJOINT_ATTRIBUTE, formValues, dispatch)
}

export const editConjointAttribute = (id, formValues) => async dispatch => {
    await auth.post(`/api/survey/conjoint/update_attribute?id=${id}`, formValues)
    .then(response => {
        dispatch({ type: EDIT_CONJOINT_ATTRIBUTE, payload: response.data })
    })
    .catch(error => {
        if (error.response.data.detail.constructor === Array) {
            const errorObj = errorObject(error.response.data.detail)
            dispatch({ type: SHOW_ERROR, payload: errorObj })
        }
        else {
            dispatch({ type: SHOW_ERROR, payload: error.response.data });
        }
    })
}

export const moveConjointAttribute = (id, attribute_id, action) => async dispatch => {
    await auth.get(`/api/survey/conjoint/move_attribute?id=${id}&attribute_id=${attribute_id}&action=${action}`)
    .then(response => {
        dispatch({ type: MOVE_CONJOINT_ATTRIBUTE, payload: response.data })
    })
    .catch(error => {
        if (error.response.data.detail.constructor === Array) {
            const errorObj = errorObject(error.response.data.detail)
            dispatch({ type: SHOW_ERROR, payload: errorObj })
        }
        else {
            dispatch({ type: SHOW_ERROR, payload: error.response.data });
        }
    })
    dispatch(fetchConjoint(id))
} 

export const deleteConjointAttribute = (id, attribute_id) => async dispatch => {
    await auth.delete(`/api/survey/conjoint/delete_attribute?id=${id}&attribute_id=${attribute_id}`)
    .then(response => {
        dispatch({ type: DELETE_CONJOINT_ATTRIBUTE, payload: response.data })
    })
    .catch(error => {
        if (error.response.data.detail.constructor === Array) {
            const errorObj = errorObject(error.response.data.detail)
            dispatch({ type: SHOW_ERROR, payload: errorObj })
        }
        else {
            dispatch({ type: SHOW_ERROR, payload: error.response.data });
        }
    })
} 

export const editConjointPrices = (id, formValues) => async dispatch => {
    await auth.post(`/api/survey/conjoint/update_prices?id=${id}`, formValues)
    .then(response => {
        dispatch({ type: EDIT_CONJOINT_PRICES, payload: response.data })
    })
    .catch(error => {
        if (error.response.data.detail.constructor === Array) {
            const errorObj = errorObject(error.response.data.detail)
            dispatch({ type: SHOW_ERROR, payload: errorObj })
        }
        else {
            dispatch({ type: SHOW_ERROR, payload: error.response.data });
        }
    })
}

export const addConjointExclusion = (id, formValues) => async dispatch => {
    await postAction(`/api/survey/conjoint/add_exclusion?id=${id}`, ADD_CONJOINT_EXCLUSION, formValues, dispatch)
}

export const editConjointExclusion = (id, formValues) => async dispatch => {
    await auth.post(`/api/survey/conjoint/update_exclusion?id=${id}`, formValues)
    .then(response => {
        dispatch({ type: EDIT_CONJOINT_EXCLUSION, payload: response.data })
    })
    .catch(error => {
        if (error.response.data.detail.constructor === Array) {
            const errorObj = errorObject(error.response.data.detail)
            dispatch({ type: SHOW_ERROR, payload: errorObj })
        }
        else {
            dispatch({ type: SHOW_ERROR, payload: error.response.data });
        }
    })
}

export const deleteConjointExclusion = (id, exclusion_id) => async dispatch => {
    await auth.delete(`/api/survey/conjoint/delete_exclusion?id=${id}&exclusion_id=${exclusion_id}`)
    .then(response => {
        dispatch({ type: DELETE_CONJOINT_EXCLUSION, payload: response.data })
    })
    .catch(error => {
        if (error.response.data.detail.constructor === Array) {
            const errorObj = errorObject(error.response.data.detail)
            dispatch({ type: SHOW_ERROR, payload: errorObj })
        }
        else {
            dispatch({ type: SHOW_ERROR, payload: error.response.data });
        }
    })
}

export const editConjointSettings = (id, formValues) => async dispatch => {
    await auth.post(`/api/survey/conjoint/update_settings?id=${id}`, formValues)
    .then(response => {
        dispatch({ type: EDIT_CONJOINT_SETTINGS, payload: response.data })
    })
    .catch(error => {
        if (error.response.data.detail.constructor === Array) {
            const errorObj = errorObject(error.response.data.detail)
            dispatch({ type: SHOW_ERROR, payload: errorObj })
        }
        else {
            dispatch({ type: SHOW_ERROR, payload: error.response.data });
        }
    })
}

export const fetchConjointPreview = (id) => async dispatch => {
    await auth.get(`/api/survey/conjoint/preview_conjoint?id=${id}`)
        .then(response => {
            dispatch({ type: FETCH_CONJOINT_PREVIEW, payload: response.data })
        })
        .catch(error => {
            dispatch({ type: SHOW_ERROR, payload: error.response.data });
            history.push('/surveys')
        })
}

export const addGaborGranger = (formValues) => async dispatch => {
    await auth.post('/api/survey/create_gabor_granger', formValues)
        .then(response => {
            const id = response.data.id
            dispatch({ type: ADD_GABOR_GRANGER, payload: response.data })
            history.push(`/surveys/gabor-granger?id=${id}`)
        })
        .catch(error => {
            if (error.response.data.detail.constructor === Array) {
                const errorObj = errorObject(error.response.data.detail)
                dispatch({ type: SHOW_ERROR, payload: errorObj })
            }
            else {
                dispatch({ type: SHOW_ERROR, payload: error.response.data });
            }
        })
}

export const fetchGaborGrangers = () => async dispatch => {
    await getAction('/api/survey/get_gabor_grangers', FETCH_GABOR_GRANGERS, dispatch)
}

export const fetchGaborGranger = (id) => async dispatch => {
    await auth.get(`/api/survey/get_gabor_granger?id=${id}`)
        .then(response => {
            dispatch({ type: FETCH_GABOR_GRANGER, payload: response.data })
        })
        .catch(error => {
            dispatch({ type: SHOW_ERROR, payload: error.response.data });
            history.push('/surveys')
        })
}

export const toggleGaborGrangerReady = (id) => async dispatch => {
    await auth.get(`/api/survey/gabor_granger/toggle_ready?id=${id}`)
        .then(response => {
            dispatch({ type: TOGGLE_GABOR_GRANGER_READY, payload: response.data })
        })
        .catch(error => {
            dispatch({ type: SHOW_ERROR, payload: error.response.data });
        })
}

export const editGaborGrangerPrices = (id, formValues) => async dispatch => {
    await auth.post(`/api/survey/gabor_granger/update_prices?id=${id}`, formValues)
    .then(response => {
        dispatch({ type: EDIT_GABOR_GRANGER_PRICES, payload: response.data })
    })
    .catch(error => {
        if (error.response.data.detail.constructor === Array) {
            const errorObj = errorObject(error.response.data.detail)
            dispatch({ type: SHOW_ERROR, payload: errorObj })
        }
        else {
            dispatch({ type: SHOW_ERROR, payload: error.response.data });
        }
    })
}

export const editGaborGrangerProduct = (id, formValues) => async dispatch => {
    await auth.post(`/api/survey/gabor_granger/update_product?id=${id}`, formValues)
    .then(response => {
        dispatch({ type: EDIT_GABOR_GRANGER_PRODUCT, payload: response.data })
    })
    .catch(error => {
        if (error.response.data.detail.constructor === Array) {
            const errorObj = errorObject(error.response.data.detail)
            dispatch({ type: SHOW_ERROR, payload: errorObj })
        }
        else {
            dispatch({ type: SHOW_ERROR, payload: error.response.data });
        }
    })
}

export const editGaborGrangerSettings = (id, formValues) => async dispatch => {
    await auth.patch(`/api/survey/gabor_granger/update_settings?id=${id}`, formValues)
    .then(response => {
        dispatch({ type: EDIT_GABOR_GRANGER_SETTINGS, payload: response.data })
    })
    .catch(error => {
        if (error.response.data.detail.constructor === Array) {
            const errorObj = errorObject(error.response.data.detail)
            dispatch({ type: SHOW_ERROR, payload: errorObj })
        }
        else {
            dispatch({ type: SHOW_ERROR, payload: error.response.data });
        }
    })
}

export const fetchGaborGrangerPreview = (id) => async dispatch => {
    await auth.get(`/api/survey/gabor_granger/preview?id=${id}`)
        .then(response => {
            dispatch({ type: FETCH_GABOR_GRANGER_PREVIEW, payload: response.data })
        })
        .catch(error => {
            dispatch({ type: SHOW_ERROR, payload: error.response.data });
            history.push('/surveys')
        })
}

export const addVanWestendorp = (formValues) => async dispatch => {
    await auth.post('/api/survey/create_van_westendorp', formValues)
        .then(response => {
            const id = response.data.id
            dispatch({ type: ADD_VAN_WESTENDORP, payload: response.data })
            history.push(`/surveys/van-westendorp?id=${id}`)
        })
        .catch(error => {
            if (error.response.data.detail.constructor === Array) {
                const errorObj = errorObject(error.response.data.detail)
                dispatch({ type: SHOW_ERROR, payload: errorObj })
            }
            else {
                dispatch({ type: SHOW_ERROR, payload: error.response.data });
            }
        })
}

export const fetchVanWestendorps = () => async dispatch => {
    await getAction('/api/survey/get_van_westendorps', FETCH_VAN_WESTENDORPS, dispatch)
}

export const fetchVanWestendorp = (id) => async dispatch => {
    await auth.get(`/api/survey/get_van_westendorp?id=${id}`)
        .then(response => {
            dispatch({ type: FETCH_VAN_WESTENDORP, payload: response.data })
        })
        .catch(error => {
            dispatch({ type: SHOW_ERROR, payload: error.response.data });
            history.push('/surveys')
        })
}

export const toggleVanWestendorpReady = (id) => async dispatch => {
    await auth.get(`/api/survey/van_westendorp/toggle_ready?id=${id}`)
        .then(response => {
            dispatch({ type: TOGGLE_VAN_WESTENDORP_READY, payload: response.data })
        })
        .catch(error => {
            dispatch({ type: SHOW_ERROR, payload: error.response.data });
        })
}

export const editVanWestendorpProduct = (id, formValues) => async dispatch => {
    await auth.post(`/api/survey/van_westendorp/update_product?id=${id}`, formValues)
    .then(response => {
        dispatch({ type: EDIT_VAN_WESTENDORP_PRODUCT, payload: response.data })
    })
    .catch(error => {
        if (error.response.data.detail.constructor === Array) {
            const errorObj = errorObject(error.response.data.detail)
            dispatch({ type: SHOW_ERROR, payload: errorObj })
        }
        else {
            dispatch({ type: SHOW_ERROR, payload: error.response.data });
        }
    })
}

export const editVanWestendorpSettings = (id, formValues) => async dispatch => {
    await auth.patch(`/api/survey/van_westendorp/update_settings?id=${id}`, formValues)
    .then(response => {
        dispatch({ type: EDIT_VAN_WESTENDORP_SETTINGS, payload: response.data })
    })
    .catch(error => {
        if (error.response.data.detail.constructor === Array) {
            const errorObj = errorObject(error.response.data.detail)
            dispatch({ type: SHOW_ERROR, payload: errorObj })
        }
        else {
            dispatch({ type: SHOW_ERROR, payload: error.response.data });
        }
    })
}